<h1 mat-dialog-title>
  <span matDialogTitle class="centered">
    {{'contactInfo.contactLabel' | transloco}}
  </span>
</h1>
<mat-dialog-content>
  <div >
    <p>{{'contactInfo.contactStartText' | transloco}}</p>
    <p>
      <strong class="wholeLine">{{'contactInfo.webshopUpgradeLabel'| transloco}}</strong>
      <span class="wholeLine"> {{'contactInfo.webshopUpgradeText'| transloco}}</span>
      <a href="{{'shop.webshopLink'| transloco}}" target="_blank">{{'shop.webshopLink'| transloco}}</a>
    </p>
    <p>
      <strong class="wholeLine">{{'contactInfo.emailSupportLabel'| transloco}}</strong>
      <span class="wholeLine"> {{'contactInfo.emailSupportText'| transloco}}</span>
      <a [href]="getEmailText('contactInfo.emailSupport')"> {{'contactInfo.emailSupport'| transloco}}</a>
    </p>
    <p>
      <strong class="wholeLine">{{'contactInfo.packoOfficeLabel'| transloco}}</strong>
      <span class="wholeLine"> {{'contactInfo.packoOfficeText'| transloco}}</span>
      <a [href]="getEmailText('contactInfo.packoOffice')"> {{'contactInfo.packoOffice' | transloco}}</a>
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="rightAligned" (click)="doConfirm()" mat-raised-button type="button"
    color="primary">{{ 'common.buttons.ok' | transloco }}</button>
</mat-dialog-actions>
